import { useState } from "react";
import { Col, Row, Button } from "reactstrap";
import { useSelector } from "react-redux";
import useExportFiltersCard from "./useExportFiltersCard";
import { Theme } from "../../../config/constants";
import FiltersWidget from "../../Filters/FiltersWidget";

const ExportFiltersCard = (props) => {
    const exportButtonActive = useSelector(({ui}) => ui.exportButtonActive);
    const { handleClickExportButton } = useExportFiltersCard.useExportFiltersCard();
    const [salesDataFilters, setSalesDataFilters] = useState({});
    const [competitiveDataFilters, setCompetitiveDataFilters] = useState({});

    return (
        <Col className="h-100">
            <Row id={`exportFiltersMain`} className="w-100 mx-0" style={{background: 'white', zIndex: '2', position: 'relative', borderRadius: '5px'}}>
                <Col>
                    <Row>
                        <Col>
                            <div className="main-header text-size-20 mt-3">Download Your Sales Data</div>
                        </Col>
                    </Row>
                    <Row style={{position: 'relative'}}>
                        <FiltersWidget 
                            saveFilterSetsEnabled={false}
                            datasetOptionsEnabled={true}
                            prechosenFilters={props.prechosenFilters}
                            filterSetOptionsEnabled={false}
                            onApplyFilters={(filters) => setSalesDataFilters(filters)}
                        />
                    </Row>
                    <Row className="mx-2 my-2">
                        <Button 
                            block 
                            className='py-1 button-label exportWidgetButton' 
                            size='md' 
                            outline={false}
                            color={Theme().colors.accentName}
                            onClick={() => handleClickExportButton(salesDataFilters, props.title, false)}
                            disabled={!exportButtonActive}
                        > Export Your Data As CSV
                        </Button>
                    </Row>
                    <Row className="pt-3">
                        <Col>
                            <div style={{height: "1px", width: "100%", background: "lightgray"}}></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="main-header text-size-20 mt-3">Download Competitive Data</div>
                        </Col>
                    </Row>
                    <Row style={{position: 'relative'}}>
                        <FiltersWidget 
                            saveFilterSetsEnabled={false} 
                            datasetOptionsEnabled={true}
                            prechosenFilters={props.prechosenFilters}
                            filterSetOptionsEnabled={false}
                            onApplyFilters={(filters) => setCompetitiveDataFilters(filters)}
                        />
                    </Row>
                    <Row className="mx-2 my-2">
                        <Button 
                            block 
                            className='py-1 button-label exportWidgetButton' 
                            size='md' 
                            outline={false}
                            color={Theme().colors.accentName}
                            onClick={() => handleClickExportButton(competitiveDataFilters, props.title, true)}
                            disabled={!exportButtonActive}
                        > Export Competitive Data As CSV
                        </Button>
                    </Row>
                    <Row className="pt-3">
                        <Col>
                            <div style={{height: "1px", width: "100%", background: "lightgray"}}></div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    )   
}

export default ExportFiltersCard;